import { Directive, Attribute, OnChanges, SimpleChanges, Input } from '@angular/core';
import {
    AbstractControl,
    UntypedFormControl,
    NG_VALIDATORS,
    ValidationErrors,
    Validator,
    ValidatorFn
} from '@angular/forms';
import * as moment from 'moment';
import { ScheduleTime } from '../interfaces/schedule-time';

/**
 * @method validateTimeScheduleFactory
 * @returns {ValidatorFn}
 */
function validateTimeScheduleFactory(timesSchedule: Array<ScheduleTime>): ValidatorFn {
    return (c: AbstractControl) => {

        cleanError(c);

        let hour: string = c.value;

        if (timesSchedule == undefined || !hour) {
            return null;
        }

        let i: number = 0;
        let isValid: boolean = false;
        let time: moment.Moment = moment(hour, 'HH:mm');

        if (!moment(hour, 'HH:mm').isValid()) {
            const error = { rangeValid: { timesSchedule } };
            return error;
        }
        while (!isValid && i < timesSchedule.length) {
            isValid = time.isBetween(timesSchedule[i].start, timesSchedule[i].end);
            i++;
        }

        if (!isValid) {
            const error = { rangeValid: { timesSchedule } };
            return error;
        }

        return null;
    };
}

function cleanError(c: AbstractControl) {
    if (c.errors !== null) {
        if (Object.keys(c.errors).length) {
            delete c.errors['rangeValid'];
            if (Object.keys(c.errors).length == 0) {
                c.setErrors(null);
            }
        }
    }
}

/**
 * Class that validates if the time value is between range.
 */
@Directive({
    selector: '[timeSchedule][formControlName],[timeSchedule],[formControl],[timeSchedule][formControl],[timeSchedule][ngModel]',
    providers: [{ provide: NG_VALIDATORS, useExisting: TimeScheduleValidator, multi: true }]
})
export class TimeScheduleValidator implements Validator, OnChanges {
    /**
     * @property {ValidatorFn} validator
     */
    validator: ValidatorFn;

    /**
     * @property {() => void} _onChange
     */
    private _onChange: () => void;

    @Input()
    public set timeSchedule(timeSchedule: Array<ScheduleTime>) {
        this._timeSchedule = timeSchedule;
        this.validator = validateTimeScheduleFactory(this._timeSchedule);
    }
    public get timeSchedule(): Array<ScheduleTime> {
        return this._timeSchedule;
    }
    _timeSchedule: Array<ScheduleTime>;

    /**
     * @constructs TimeScheduleValidator
     *
     * @param {number} timeSchedule
     */
    constructor(@Attribute('timeSchedule') timeSchedule: Array<ScheduleTime>) {
        this.timeSchedule = timeSchedule;
    }

    /**
     * @method validate
     * @param {FormControl} c
     * @returns {ValidationErrors}
     */
    validate(c: UntypedFormControl): ValidationErrors {
        return this.validator(c);
    }

    registerOnValidatorChange(fn: () => void): void { this._onChange = fn; }

    ngOnChanges(changes: SimpleChanges) {
        if (this._onChange) { this._onChange(); }
    }
}
